import { useQuery } from '@tanstack/react-query';
import { api } from './api';
import { useLocale } from './i18n';

/** The shop's published content pages, so links only point at pages that exist. */
export function usePages() {
  const locale = useLocale();
  const { data = [] } = useQuery({ queryKey: ['pages', locale], queryFn: () => api<{ title: string; slug: string }[]>('/api/store/pages'), staleTime: 60_000 });
  return { pages: data, has: (slug: string) => data.some((p) => p.slug === slug) };
}
